export type AppliedFilter = {
    format?: string;
    isIgnored?: boolean;
    includeNull?: boolean;
    appliedValues?: Record<string, boolean>;
};

export type SchemaItem = {
    field: string;
    param: string;
    includeNullAs?: number;
    mapValue?: (v: number) => number;
};

export function extractArrayFromApplied(
    f?: AppliedFilter,
    opts?: { includeNullAs?: number; mapValue?: (key: string) => number | undefined | null }
): { value?: number[]; hardEmpty: boolean } {
    if (!f) return { value: undefined, hardEmpty: false };
    if (f.isIgnored) return { value: [], hardEmpty: false };

    const activeKeys = Object.entries(f.appliedValues ?? {})
        .filter(([, checked]) => checked)
        .map(([k]) => k);

    if (activeKeys.length === 0 && !f.includeNull) return { value: [], hardEmpty: true };

    let rawValues: Array<number | undefined | null> = [];
    if (opts?.mapValue) {
        rawValues = activeKeys.map(opts.mapValue);
    } else {
        rawValues = activeKeys.map(k => Number(k));
    }

    const values = (rawValues.filter(v => typeof v === 'number' && !Number.isNaN(v)) as number[]);

    if (f.includeNull) values.push(opts?.includeNullAs ?? -1);

    return { value: values, hardEmpty: false };
}

export function appliedFiltersToArrayParams(
    appliedFilters: Record<string, AppliedFilter> | undefined,
    schema: SchemaItem[]
): { params: Record<string, number[] | undefined>; hardEmpty: boolean } {
    const params: Record<string, number[] | undefined> = {};
    let hardEmpty = false;

    schema.forEach(s => {
        const res = extractArrayFromApplied(appliedFilters?.[s.field], {
            includeNullAs: s.includeNullAs ?? -1,
            mapValue: s.mapValue
        });
        if (res.hardEmpty) hardEmpty = true;
        params[s.param] = res.value;
    });

    return { params, hardEmpty };
}


